import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { AjusteDeEstoqueDTO, AjusteDeEstoqueResponseDTO } from '../../models/estoque/ajuste-estoque.model';
import { ApiInterface } from '../api-interface';

@Injectable({
  providedIn: 'root',
})
export class AjusteEstoqueService implements ApiInterface {

  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<AjusteDeEstoqueResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<AjusteDeEstoqueResponseDTO>(path);
  }

  post<T>(url: string, data: AjusteDeEstoqueDTO): Observable<AjusteDeEstoqueDTO> {
    return this.apiService.create<AjusteDeEstoqueDTO>(url, data);
  }

  put<T>(url: string, data: any): Observable<any> {
    return this.apiService.update<any>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
